import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const PatientSelectionStep = ({
  formData,
  referrals,
  contacts,
  onInputChange,
  onReferralSelection,
  onReferrerSelection
}) => {
  const handlePatientSourceChange = (e) => {
    onInputChange({ target: { name: 'patientSource', value: e?.target?.value } });
  };

  const handleReferralChange = (referralId) => {
    onInputChange({ target: { name: 'selectedReferralId', value: referralId } });
    if (referralId) {
      onReferralSelection(referralId);
    }
  };

  const handleReferrerChange = (contactId) => {
    if (contactId) {
      onReferrerSelection(contactId);
    }
  };

  // Convert referrals to options format for Select component
  const referralOptions = referrals?.map(referral => ({
    value: referral?.id,
    label: `${referral?.patientFirstName} ${referral?.patientLastName} - ${referral?.referringDentistName}`
  })) || [];

  // Convert contacts to options format for Select component
  const contactOptions = contacts?.map(contact => ({
    value: contact?.id,
    label: `Dr ${contact?.dentistName} - ${contact?.practiceName}`
  })) || [];

  return (
    <div className="space-y-8">
      {/* Patient Source Selection */}
      <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/30 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
        <h3 className="text-xl font-semibold text-white mb-6 flex items-center gap-3">
          <Icon name="User" size={24} className="text-blue-400" />
          Sélection du patient
        </h3>

        <div className="space-y-6">
          {/* Patient Source Toggle */}
          <div className="flex gap-4">
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="radio"
                name="patientSource"
                value="existing"
                checked={formData?.patientSource === 'existing'}
                onChange={handlePatientSourceChange}
                className="w-4 h-4 text-blue-500"
              />
              <span className="text-gray-300">Depuis un adressage existant</span>
            </label>
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="radio"
                name="patientSource"
                value="manual"
                checked={formData?.patientSource === 'manual'}
                onChange={handlePatientSourceChange}
                className="w-4 h-4 text-blue-500"
              />
              <span className="text-gray-300">Saisie manuelle</span>
            </label>
          </div>

          {/* Existing Referral Selection */}
          {formData?.patientSource === 'existing' && (
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Adressage
              </label>
              <Select
                value={formData?.selectedReferralId}
                onChange={handleReferralChange}
                options={referralOptions}
                placeholder="Sélectionner un adressage"
                searchable={true}
              />
            </div>
          )}

          {/* Manual Patient Entry */}
          {formData?.patientSource === 'manual' && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
                label="Prénom du patient"
                name="patientFirstName"
                value={formData?.patientFirstName}
                onChange={onInputChange}
                required
              />
              <Input
                label="Nom du patient"
                name="patientLastName"
                value={formData?.patientLastName}
                onChange={onInputChange}
                required
              />
              <Input
                label="Année de naissance"
                name="patientYearOfBirth"
                type="number"
                value={formData?.patientYearOfBirth}
                onChange={onInputChange}
                placeholder="1990"
              />
              <Input
                label="Référence patient (optionnel)"
                name="patientIdReference"
                value={formData?.patientIdReference}
                onChange={onInputChange}
                placeholder="ID logiciel cabinet"
              />
            </div>
          )}
        </div>
      </div>

      {/* Referrer Information */}
      <div className="bg-gradient-to-br from-gray-900/50 to-gray-800/30 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
        <h3 className="text-xl font-semibold text-white mb-6 flex items-center gap-3">
          <Icon name="Stethoscope" size={24} className="text-green-400" />
          Confrère adresseur
        </h3>

        <div className="space-y-4">
          {/* Quick Select from Contacts */}
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Sélectionner depuis les contacts
            </label>
            <Select
              onChange={handleReferrerChange}
              options={contactOptions}
              placeholder="Choisir un contact"
              searchable={true}
            />
          </div>

          {/* Manual Referrer Entry */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input
              label="Nom du confrère"
              name="referrerName"
              value={formData?.referrerName}
              onChange={onInputChange}
              placeholder="Dr Dupont"
            />
            <Input
              label="Spécialité"
              name="referrerSpecialty"
              value={formData?.referrerSpecialty}
              onChange={onInputChange}
              placeholder="Omnipraticien"
            />
            <Input
              label="Cabinet"
              name="referrerPractice"
              value={formData?.referrerPractice}
              onChange={onInputChange}
              placeholder="Cabinet dentaire"
            />
            <Input
              label="Email"
              name="referrerEmail"
              type="email"
              value={formData?.referrerEmail}
              onChange={onInputChange}
              placeholder="contact@cabinet.fr"
            />
            <Input
              label="Téléphone"
              name="referrerPhone"
              value={formData?.referrerPhone}
              onChange={onInputChange}
              placeholder="01 23 45 67 89"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientSelectionStep;